import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

import { connect } from "react-redux";
import Select from "react-select"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Loader from "components/Loader/Loader";
import { deleteLevel, fetchAllLevel, updateLevel } from "helpers/level_helper";
import { toast } from "react-toastify";
import { success } from "toastr";

const AllDifficultys = (props) => {
    document.title = "Content Management | All Levels";
    const [modalShow, setModalShow] = useState(false);
    const [name, setName] = useState("");
    const [id, setId] = useState({});
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [allLevels, setAllLevels] = useState([]);
    const dispatch = useDispatch();


    const breadcrumbItems = [
        { title: "Level", link: "#" },
        { title: "All Levels", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems('All Levels', breadcrumbItems)
    })

    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    const getAllLevel = async () => {
        try {
            setLoader(true);
            const result = await fetchAllLevel();
            if (result?.success) {
                setAllLevels(result?.result);
            }
            else {
                toast.error(result?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
        }

    }


    useEffect(() => {
        getAllLevel();
    }, []);


    const data = {
        columns: [
            {
                label: "Serial No.",
                field: "serialNo",
                sort: "asc",
                width: 50,
            },
            {
                label: "Name",
                field: "name",
                sort: "asc",
                width: 50,
            }
        ],
        rows: allLevels?.map((row, index) => ({
            ...row,
            serialNo: index + 1, // Add 1 to start counting from 1
            clickEvent: () => handleRowClick(row),
        })),
    };


    const handleRowClick = (row) => {

        setModalShow(true);

        setId(row.id);
        setName(row.name);
    }

    const handleUpdate = async () => {
        if (!name) {
            setSpanDisplay("inline")

        }
        else {

            try {
                setLoader(true);
                const result = await updateLevel({ id, name });

                if (result?.success) {
                    toast.success(result?.message);
                    getAllLevel();
                    setModalShow(false);
                    setName("");
                    setId("");
                }
                else {
                    toast.error(result?.message);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message);
            } finally {
                setLoader(false);
            }



        }
    }




    const handleDelete = async () => {
        try {
            setLoader(true)
            const result = await deleteLevel(id);
            if (result?.success) {
                toast.success(result?.message);
                getAllLevel();
                setModalShow(false);
                setDeleteModalShow(false)
                setName("");
                setId("");
            }
            else {
                toast.error(result?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
        }

    }

    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row  >
                <Col className="col-12">
                    <Card>
                        <CardBody className="col-lg-6 col-sm-12 col-xs-12"   >
                            <CardTitle className="h4">All Levels </CardTitle>
                            <MDBDataTable className="table-row-hover" responsive bordered data={data} style={{ cursor: 'pointer' }} noBottomColumns />
                        </CardBody>

                    </Card>
                </Col>
            </Row>

            <Modal
                show={modalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Level
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Level Name
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Level"
                                maxLength="50"
                                value={name}
                                onChange={(e) => setName(e.target.value)} />
                            {!name && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setModalShow(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdate} className="waves-effect waves-light">Update</Button>{" "}
                    <Button type="button" color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false) }} className="waves-effect waves-light">Delete</Button>{" "}
                </Modal.Footer>
            </Modal>

            <Modal
                show={deleteModalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <h4>
                        Are you sure want to remove this Level.
                    </h4>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setDeleteModalShow(false); setModalShow(true) }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDelete} className="waves-effect waves-light">Yes</Button>{" "}

                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(AllDifficultys);